define('modules/editor/views/correodirect_option_view',['require','exports','module','base/itemview','../../editor/models/editorstate','ldsh!../templates/correodirect_option_view'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview");

  /* Sure there is a better way to do this, but it means refactor */
  var EditorState = require("../../editor/models/editorstate");

  module.exports = ItemView.extend({
    className: "ed-form-group ed-form-group-inline ed-user-item hidden",
    template: require("ldsh!../templates/correodirect_option_view"),
    events: {
      "change select": "updateIntegration"
    },
    helpers: function() {
      var translationKey = this.model.get("translationKey");
      try {
        var defaultsModel = EditorState.getVariant().getPropertyGroup("page:defaults"),
            lang = defaultsModel.get("language");
        if (translationKey) translationKey += ("_" + lang);
      } catch(e) {}
      return {
        localizedTranslationKey: translationKey
      };
    },
    onRender: function() {
      if (!this.model.get("valid")) return;
      this.$el.removeClass("hidden");
      this._renderLists();
      this.$el.i18n();
    },
    _renderLists: function() {
      var combo = this.$("select");
      var mappedField = this.model.get("correodirectBinding");
      combo.empty();
      if (!mappedField) combo.append($("<option/>"));
      //add default fields
      _.each(this.model.correodirectBindingOptions, function(name){
        var item = $("<option />")
          .attr("value", name)
          .text(name);

        if(name === mappedField){
          item.attr("selected", "selected");
        }
        combo.append(item);
      }, this);
    },
    updateIntegration: function(e) {
      var value = this.$("select :selected").attr("value");
      this.model.set("correodirectBinding", value);
    }
  });
});

